"use strict";
var Observable_1 = require('../../Observable');
var zip_1 = require('../../operator/zip');
Observable_1.Observable.prototype.zip = zip_1.zipProto;
//# sourceMappingURL=zip.js.map


//////////////////
// WEBPACK FOOTER
// C:/DEV/saaristonsiirin/~/rxjs/add/operator/zip.js
// module id = ../../../../rxjs/add/operator/zip.js
// module chunks = 3